import { defineType, ValidationContext } from "sanity";
import { inclusionCodes } from "../data-types/inclusionsTokens";

export interface FareInfographic {
  type: FareInfographicType;
}

type FareInfographicType = (typeof fareInfographicsTypes)[number];

const fareInfographicsTypes = ["Ocean" as const, "Expedition" as const];

export default defineType({
  name: "fareInfographic",
  title: "Fare Infographic",
  type: "object",
  fields: [
    {
      name: "type",
      title: "Type",
      type: "string",
      options: {
        list: fareInfographicsTypes,
        layout: "dropdown"
      },
      validation: (Rule) => Rule.required()
    },
    {
      name: "enabledInclusions",
      type: "array",
      of: [{ type: "string" }],
      options: { list: inclusionCodes },
      validation: (Rule) => Rule.required()
    },
    {
      name: "infographicServicesDisclaimer",
      title: "Services disclaimer",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "infographicFooterNotes",
      title: "Footer notes",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "infographicFooterNotesForNonAirCountries",
      title: "Footer disclaimer for non-air countries",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "refundCreditExchangeFooterNotes",
      title: "Refund Credit Exchange footer notes",
      type: "multilingualArrayBlockContent"
    }
  ]
});
